import React from 'react'
import moment from "moment"
export default function CalculationSummary({userRequest}) {
    return (
        <div className="calc-summary-holder">
        <div className="summary-col">
          <div className="summary-info-row">
            <p>الراتب الاساسي</p>
            <h6>
              {userRequest?.Customer?.Salary} <span>ر.س</span>
            </h6>
          </div>
          <div className="summary-info-row">
            <p>بدل نقل</p>
            <h6>
            {userRequest?.Customer?.TransportationAllowance} <span>ر.س</span>
            </h6>
          </div>
          <div className="summary-info-row">
            <p>بدل سكن</p>
            <h6>
            {userRequest?.Customer?.HousingAllowance} <span>ر.س</span>
            </h6>
          </div>
        </div>

        <div className="summary-col">
        <div className="summary-info-row">
            <p>المديونيات</p> 
            <h6 style={{ color: "#CC3524" }}>
              {userRequest?.TotalIndebtednesses} <span>ر.س</span>
            </h6>
          </div>
          <div className="summary-info-row">
            <p>السعي</p>
            <h6 style={{ color: "#C2A062" }}>
              {userRequest?.Profit} <span>{userRequest?.IsRatio ? "%" : "ر.س"}</span>
            </h6>
          </div>
          {userRequest?.RealestateFinancingRequest &&
          <div className="summary-info-row">
            <p>سعر العقار</p>
            <h6 style={{ color: "#C2A062" }}>
              {userRequest?.RealestateFinancingRequest?.RealestatePrice} <span>ر.س</span>
            </h6>
          </div>
          }
        </div>

        <div className="summary-col">
          <div className="summary-info-row">
            <p>مدعوم</p>
            <h5>{userRequest?.Customer?.IsSupported ? "نعم" : "لا"}</h5>
          </div>
          <div className="summary-info-row">
            <p>العمر</p>
            <h5>
              {moment().diff(userRequest?.Customer?.BirthDate, 'years')} <span>سنه</span>{" "} 
            </h5>
          </div>
          <div className="summary-info-row">
            <p>جهه العمل</p>
            <h5>
            {userRequest?.Customer?.Employer?.NameLT} <span>{userRequest?.Customer?.JobTitle?.NameLT}</span>{" "}
            </h5>
          </div>
        </div>
      </div>
    )
}

